/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_TitleInputs */

const en_cp_ask_title = /** @type {(inputs: Cp_Ask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The partner gives`)
};

const id_cp_ask_title = /** @type {(inputs: Cp_Ask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitra memberi`)
};

/**
* | output |
* | --- |
* | "The partner gives" |
*
* @param {Cp_Ask_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_title = /** @type {((inputs?: Cp_Ask_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_title(inputs)
	return en_cp_ask_title(inputs)
});